import { render, staticRenderFns } from "./ReenvoiInvitationDialog.vue?vue&type=template&id=308a8e70&"
import script from "./ReenvoiInvitationDialog.vue?vue&type=script&lang=js&"
export * from "./ReenvoiInvitationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports